export default "__VITE_ASSET__BpeneDoK__"